export enum ButtonPosition {
    Left,
    Right,
}
